import { CaretDownOutlined, DownOutlined, LogoutOutlined, PoweroffOutlined, UserOutlined } from '@ant-design/icons'
import { Avatar, Button, Card, Dropdown, Tag, Tooltip } from 'antd'
import React, { useContext } from 'react'
import { AuthContext } from '../Context/AuthContext'
import { useNavigate } from 'react-router-dom'

function PageTitle({ title }) {
    const auth = useContext(AuthContext);
    const navigate = useNavigate();

    const getInitials = (value) => {
        const splitValue = value.split(' ');
        const initials = splitValue.reduce((item, curItem) => {
            return item[0] + curItem[0]
        });
        return initials
    }

    const items = [
        {
            label: <Button onClick={() => navigate('/my-profile')} type='link' className='d-flex align-items-center'><UserOutlined className='' /> My Profile</Button>,
            key: '0',
        },
        {
            label: <Button type='link' style={{ color: '#ff0000' }} className='d-flex align-items-center' onClick={auth.handleLogout}><PoweroffOutlined className='' /> Logout</Button>,
            key: '1',
        },
    ];

    return (
        <Card className='mb-3' bordered={false}>
            <div className="page-title-wrap row align-items-center">
                <div className="col-4">
                    <h3 className='m-0 fw-semibold'>{title}</h3>
                </div>
                <div className="col-4 text-center">
                    {
                        window.location.host.includes('jswcement') &&
                        <Tag className='fw-bold h6 h-auto m-0 py-2 px-4 rounded-5' style={{ borderColor: '#174897', backgroundColor: '#e9f2ff', color: '#174897' }}>JSW Cement</Tag>
                    }
                    {
                        window.location.host.includes('jspsteel') &&
                        <Tag className='fw-bold h6 h-auto m-0 py-2 px-4 rounded-5' style={{ borderColor: '#d46500', backgroundColor: '#ffeddc', color: '#d46500' }}>JSP Steel</Tag>
                    }
                </div>
                <div className="col-4 d-flex align-items-center justify-content-end">

                    <Dropdown
                        menu={{
                            items,
                        }}
                        placement="topLeft"
                        arrow={{
                            pointAtCenter: true,
                        }}
                        overlayClassName="userinfo-dropdown"
                        trigger={['click']}
                    >
                        <div className="d-inline-flex align-items-center" style={{ cursor: 'pointer' }}>
                            {auth?.currentUser?.attachment_url === '' ?
                                <Avatar size={40}>{getInitials(auth?.currentUser?.agency_name)}</Avatar>
                                :
                                <Avatar size={40} src={auth?.currentUser?.attachment_url} />
                            }
                            <div className='text-muted welcome-text'>
                                <small>Welcome,</small>
                                <div className="h5 mb-0 text-dark">{auth.currentUser.agency_name}</div>
                            </div>
                            <DownOutlined className='ms-2' style={{ fontSize: 8 }} />
                        </div>
                    </Dropdown>
                    {/* <Tooltip className='title-logout-btn' title="Logout">
                        <Button onClick={auth.handleLogout} type="dashed" icon={<PoweroffOutlined />} className="ms-sm-4 ms-1 mb-0" size='large' shape='circle' danger />
                    </Tooltip> */}
                </div>
            </div>


        </Card>
    )
}

export default PageTitle